module.exports = __webpack_public_path__ + "media/src/images/top_covers/2horizon-f95d8fc5121f4e3295976a0107121158.png";